<template>
    <v-container>
        <CustomHeading
            :breadcrumbs="breadcrumbs"
        />

        <v-row class="justify-center">
            <!--Card-->
            <v-col cols="12" md="7">
                <v-card class="mb-3 pa-4" outlined>
                    <!--Card title-->
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8" style="font-size: 18px; font-weight: 500;">Učenici</v-col>
                    </v-row>
                    <v-row class="mb-4">
                        <v-col cols="12">
                                <div class="text-subtitle-2 font-weight-regular mb-3">Odaberite filter po godini rođenja zbog lakšeg dodavanja učenika.</div>
                                <v-autocomplete
                                    :items="years"
                                    label="Odaberite godinu rođenja"
                                    v-model="selectedYears"
                                    height="44"
                                    dense
                                    chips
                                    small-chips
                                    multiple
                                    clearable
                                    hide-details
                                    outlined
                                    single-line
                                    hide-no-data
                                >
                                </v-autocomplete>
                        </v-col>
                    </v-row>
                    <!--Card body-->
                    <v-form>
                        <v-row v-for="(item, index) in departmentUsers" :key="index">
                            <v-col cols="4">
                                <v-subheader class="justify-end">Učenik/ca: </v-subheader>
                            </v-col>
                            <v-col v-if="item.id" cols="6">
                                    <v-autocomplete
                                        :items="item.allUsers"
                                        item-value="id"
                                        item-text="full_name"
                                        v-model="item.id"
                                        height="44"
                                        @input="addUserField"
                                        dense
                                        hide-details
                                        outlined
                                        single-line
                                        hide-no-data
                                        disabled
                                    >
                                        <template slot="item" slot-scope="{item}">
                                            {{item.full_name}} - {{item.aai_email ? item.aai_email : ''}}
                                        </template>
                                        <template slot="selection" slot-scope="{item}">
                                            {{item.full_name}} - {{item.aai_email ? item.aai_email : ''}}
                                        </template>
                                    </v-autocomplete>
                            </v-col>

                            <v-col v-else cols="6">
                                    <v-autocomplete
                                        :items="item.users"
                                        placeholder="Odaberite učenika"
                                        item-value="id"
                                        item-text="full_name"
                                        v-model="item.id"
                                        height="44"
                                        @input="addUserField"
                                        dense
                                        hide-details
                                        outlined
                                        single-line
                                        hide-no-data
                                    >
                                        <template slot="item" slot-scope="{item}">
                                            {{item.full_name}} - {{item.aai_email}}
                                        </template>
                                        <template slot="selection" slot-scope="{item}">
                                            {{item.full_name}} - {{item.aai_email}}
                                        </template>
                                    </v-autocomplete>
                            </v-col>
                            <v-col class="d-flex justify-end">
                                <v-btn
                                    height="44"
                                    style="min-width: 44px; width: 44px"
                                    class="red darken-2 elevation-0"
                                    @click="deleteUserField(index)"
                                >
                                    <v-icon size="20" color="white">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="8">
                                <v-btn
                                    height="44"
                                    text
                                    class="text-none secondary--text"
                                    @click="addUserField"
                                >
                                    + Dodaj polje
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
            </v-col>
            <!--Action buttons-->

            <v-col cols="12" md="3">
                <v-btn
                    color="primary"
                    class="text-none elevation-0"
                    height="44"
                    block
                    @click="updateDepartmentUsers"
                >
                    Potvrdi
                </v-btn>
                <v-btn
                    class="mt-4 custom-btn-blue text-none"
                    height="44"
                    color="primary"
                    @click="goBack()"
                    block
                    outlined
                >Odustani</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {serverBus} from "@/main";
    import CustomHeading from '@/components/heading/CustomHeading';
    import ApiV2 from "@/services/ApiV2";

    export default {
        components: {
            CustomHeading
        },
        data() {
            return {
                departmentUsers: [],
                selectedYears: [],
                users: [],
                allUsers: [],
                departmentId: this.$route.params.odjeljenje_id,
                breadcrumbs: [
                    {text: 'Administracija'},
                    {text: 'E-matica'},
                    {text: 'Odjeli'}
                ],
            }

        },
        created() {
            this.getData()
        },

        watch: {
            selectedYears() {
                this.getUsers();
            },
            currentSchool: {
                handler() {
                    this.$store.dispatch("setSchoolFieldId", null)
                    this.$router.push("/admin/odjeljenje")
                },
                deep: true
            }
        },

        computed: {
            years() {
                const d = new Date(), arr = [];

                for(let i = d.getFullYear(); i >= d.getFullYear() - 25; i--){
                    arr.push(i);
                }
                return arr;
            },
            currentSchool() {
                return this.$store.getters.getSchool;
            },
        },

        methods: {
            async getData() {
                await this.getUsers();
                this.getDepartmentUsers();
            },

            getDepartmentUsers() {
                return new Promise((resolve) => {
                    ApiV2.get(`departments/${this.departmentId}`,{params: {with: "users"}})
                        .then(response => {
                            this.departmentUsers = response.data.users;

                            this.departmentUsers.forEach(item => {
                                item.allUsers = this.allUsers;
                                item.users = this.users;
                            });

                            this.addUserField();
                            resolve();
                        });
                })
            },
            getUsers() {
                return new Promise(resolve => {
                    ApiV2.get(`users`, {
                        params: {
                            role: 10,
                            perPage: -1,
                            birthYear: this.selectedYears
                        }
                    })
                    .then(response => {
                        if(this.selectedYears.length > 0){
                            this.users = response.data.data;
                        } else if(this.selectedYears.length === 0){
                            this.users = response.data.data;
                            this.allUsers = response.data.data;
                        } else {
                            this.allUsers = response.data.data;
                        }

                        if(this.departmentUsers) {
                            this.departmentUsers.forEach(item => {
                                item.allUsers = this.allUsers;
                                item.users = this.filterUsers(this.users);
                            });
                        }
                        resolve();
                    })
                })

            },

            filterUsers(users) {
                if(this.departmentUsers) {
                    let ids = this.departmentUsers.map(user => user.id);
                    return users.filter(item => ids.indexOf(item.id) === -1);
                } else {
                    return users;
                }
            },

            goBack() {
                this.$router.push({path: `/admin/odjeljenje/pregled/${this.$route.params.odjeljenje_id}`,query: { tab: 1 }})
            },

            addUserField(){
                this.departmentUsers.push({
                    id: null,
                    users: (this.users.length > 0 || this.selectedYears.length > 0) ? this.filterUsers(this.users) : this.filterUsers(this.allUsers),
                    allUsers: this.allUsers
                });
            },
            deleteUserField(index){
                this.departmentUsers.splice(index, 1);

                // ako je korisnik obrisan pa ga nema u novom fieldu
                this.departmentUsers.forEach((user, i) => {
                    if(user.id === null){
                        this.departmentUsers.splice(i, 1);
                        this.addUserField();
                    }
                })
            },
            updateDepartmentUsers() {
                const data = this.departmentUsers.filter(el => el.id !== null).map(el => el.id);

                ApiV2.post(`departments/${this.departmentId}/users`, {
                    data: data,
                    method: "sync"
                }).then(response => {
                    serverBus.$emit("show-snackbar", true, "Uspješno ste ažurirali odjeljenje.");
                    this.departmentUsers = response.data.users;

                    this.goBack();
                })
            }
        }
    }
</script>
